import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=c9d568de"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../szc.cycz.cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/szc.cycz.cc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9d568de')) {
      api.createRecord('c9d568de', component.options)
    } else {
      api.reload('c9d568de', component.options)
    }
    module.hot.accept("./contact.vue?vue&type=template&id=c9d568de", function () {
      api.rerender('c9d568de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerInfo/generateContract/contact.vue"
export default component.exports